export type PermissionStatus = 'granted' | 'denied' | 'prompt' | 'unknown';

interface Coordinates {
  latitude: number;
  longitude: number;
}

class LocationPermissionService {
  private static instance: LocationPermissionService;
  private permissionStatus: PermissionStatus = 'unknown';

  private constructor() {
    this.init();
  }

  // Inicializa y escucha los cambios de permiso
  private async init() {
    if (!('permissions' in navigator)) {
      console.warn('Permissions API no soportada en este navegador.');
      this.permissionStatus = 'unknown';
      return;
    }

    try {
      const status = await navigator.permissions.query({ name: 'geolocation' });
      this.permissionStatus = status.state as PermissionStatus;

      status.onchange = () => {
        this.permissionStatus = status.state as PermissionStatus;
      };
    } catch (error) {
      console.error('Error consultando permisos de geolocalización:', error);
      this.permissionStatus = 'unknown';
    }
  }

  // Singleton
  public static getInstance(): LocationPermissionService {
    if (!LocationPermissionService.instance) {
      LocationPermissionService.instance = new LocationPermissionService();
    }
    return LocationPermissionService.instance;
  }

  // Retorna el estado actual del permiso
  public getPermissionStatus(): PermissionStatus {
    return this.permissionStatus;
  }

  // Obtiene las coordenadas actuales si el permiso es concedido
  public async getCurrentCoordinates(): Promise<Coordinates> {
    try {
      if (!navigator.geolocation) {
        throw new Error('Geolocalización no soportada.');
      }

      const position = await new Promise<GeolocationPosition>(
        (resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        }
      );

      return {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      console.warn(`Error al obtener ubicación: ${(error as Error).message}`);
      return {
        latitude: 0,
        longitude: 0,
      };
    }
  }
}

export const locationPermissionService =
  LocationPermissionService.getInstance();
